import { render, staticRenderFns } from "./MenuItemList.vue?vue&type=template&id=d7b0a318&"
import script from "./MenuItemList.vue?vue&type=script&lang=js&"
export * from "./MenuItemList.vue?vue&type=script&lang=js&"
import style0 from "./MenuItemList.vue?vue&type=style&index=0&id=d7b0a318&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports